import * as React from 'react'

import type { Variant } from 'content-components/_Primatives/Button'
import Button from 'content-components/_Primatives/Button'

type Props = {
  children: React.ReactNode
  className?: string
  variant?: Variant
}

SecondaryLoginButton.defaultProps = {
  className: '',
  variant: 'primary',
}

const clickPrimaryLoginButton = () => {
  const button: HTMLElement | null = document.getElementById('login-button')
  if (button) {
    button.click()
  }
}

function SecondaryLoginButton(props: Props) {
  const { children, className, variant } = props

  return (
    <Button
      className={className}
      variant={variant}
      onClick={clickPrimaryLoginButton}
    >
      {children}
    </Button>
  )
}

export default SecondaryLoginButton
